'use client';

// import { EarnRewardsSection } from '@/components/early/EarnRewardsSection';
import { GovernanceCalendar } from '@/components/early/GovernanceCalendar';
import { AITerminalWidget } from '@/components/early/AITerminalWidget';
import { FeaturedProjectSection } from '@/components/early/FeaturedProjectSection';
// import { ModeRewardsSection } from '@/components/early/ModeRewardsSection';
import { SeasonDetailsBanners } from '@/components';
import { useEcosystemDapps } from '@/hooks/content/hooks';
import { useMemo } from 'react';
// import { DappIncentivesSection } from '@/components/early/DappIncentivesSection';
import { useRouter } from 'next/navigation';
import { useSuggestions } from '@/hooks/content/hooks/useSuggestions';

const ModeDashboardBanner = () => {
  return (
    <div
      style={{
        ['--image-url' as string]: `url('/assets/images/mode_dashboard_banner.png')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      className="flex justify-center items-center h-[257px] w-full min-h-[257px] bg-[image:var(--image-url)]"
    >
      <h1 className={`font-chakra z-10 relative text-5xl uppercase text-neutral-100 text-center`}>
        <b>Mode</b> Dashboard
      </h1>
    </div>
  );
};

export const Dashboard = () => {
  const router = useRouter();
  const { data: dapps, isLoading: isEcosystemDappsLoading } = useEcosystemDapps();
  const { data } = useSuggestions();

  const featuredProjects = useMemo(() => {
    return dapps?.filter((dapp) => dapp.featured) || [];
  }, [dapps]);

  const redirectUserToTerminalChat = async (input: string) => {
    if (input) {
      router.push(`/terminal/chat?input=${input}`);
    }
  };

  return (
    <main className="animate-appear">
      <ModeDashboardBanner />
      <div className="border border-neutral-950 border-x-0 mt-1 px-[15px] xl:px-0">
        <div className="mx-auto max-w-[1200px]">
          <div className="mt-[-50px]">
            <SeasonDetailsBanners />
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-[1200px] gap-y-20 pt-10 pb-20 bg-neutral-black gap-x-8 flex flex-col px-[15px] xl:px-0">
        <div className="flex flex-col gap-y-8">
          <AITerminalWidget
            onPromptSubmit={redirectUserToTerminalChat}
            suggestions={data?.dashboardWidget.suggestions || []}
          />
          <GovernanceCalendar />
          {/* <DappIncentivesSection /> */}
          {/* <EarnRewardsSection /> */}
        </div>
        {/* <ModeRewardsSection /> */}
        <FeaturedProjectSection
          title="Featured projects"
          projects={featuredProjects}
          isLoading={isEcosystemDappsLoading}
        />
      </div>
    </main>
  );
};
